import RacecardAndResultHeader from "./shared/RacecardAndResultWidgetHeader";
import RacecardAndResultWidgetContainer from "./shared/RacecardAndResultWidgetContainer";
import RacecardAndResultWidgetRaceDescription from "./shared/RacecardAndResultWidgetRaceDescription";
import RacecardAndResultWidgetRunnerContainer from "./shared/RacecardAndResultWidgetRunnerContainer";
import {
  ResultRes,
  RacecardRes,
} from "../../../../types/races/racecardAndResultWidget";
import { TouchableOpacity, View } from "react-native";
import usePressableProps from "../../../../hooks/usePressableProps";
import { prepareParams } from "../../../Screens/Results/utils";
import { logEvent } from "../../../../client/analytics/trackPageView";

/**
 * RacecardAndResultWidgetSimple displays a simple racecard or result widget
 *
 * This renders on narrower screens - the breakpoint is set in RacecardAndResultWidget
 *
 * @property {RacecardRes | ResultRes} data - The racecard or result data to display
 * @property {boolean} [isRacecard] - Indicates if the data is for a racecard (default: false, meaning it's a result)
 *
 * @returns {JSX.Element} The RacecardAndResultWidgetSimple component
 */

type Props = {
  data: RacecardRes | ResultRes;
  isRacecard?: boolean;
  isSingleRace?: boolean;
  multiday?: boolean;
};

const RacecardAndResultWidgetSimple = ({
  data,
  isRacecard,
  isSingleRace = true,
  multiday = false,
}: Props) => {
  const pressableProps = usePressableProps({
    screen: isRacecard ? "IndividualRacecard" : "IndividualResult",
    params: prepareParams({
      date: data?.meeting?.date,
      track: data?.meeting?.track?.slug,
      ...(isRacecard
        ? { startTime: data?.start_time_scheduled }
        : { time: data?.start_time_scheduled }),
    }),
    preNavAction: () => {
      logEvent({
        key: `${
          multiday
            ? "multi-day-widget-click"
            : isSingleRace
            ? "single-race-widget-click"
            : "single-day-widget-click"
        }`,
        data: {},
      });
    },
  });

  return (
    <TouchableOpacity {...pressableProps}>
      <RacecardAndResultWidgetContainer
        isResult={!isRacecard}
        isSingleRace={isSingleRace}
      >
        <View>
          <RacecardAndResultHeader data={data} isRacecard={isRacecard} />
          <RacecardAndResultWidgetRaceDescription
            isResult={!isRacecard}
            data={data}
          />
        </View>
        <RacecardAndResultWidgetRunnerContainer
          data={data}
          isRacecard={isRacecard}
          isDetailed={false}
        />
      </RacecardAndResultWidgetContainer>
    </TouchableOpacity>
  );
};

export default RacecardAndResultWidgetSimple;
